import type { LicenseResponseBody } from '@/features/Licenses/api/licenseHooks'
import type { LicenseActionId } from '@/features/Licenses/lib/deriveActions'
import { Dialog, Portal } from '@chakra-ui/react'
import type { FC } from 'react'
import { EditEntitlementsForm } from './EditEntitlementsForm'
import { EditMetadataForm } from './EditMetadataForm'
import { ReactivateForm } from './ReactivateForm'
import { RenewForm } from './RenewForm'
import { RevokeForm } from './RevokeForm'

type FormProps = {
  license: LicenseResponseBody
  onSuccess: () => void
}

const FORMS: Record<LicenseActionId, FC<FormProps>> = {
  editEntitlements: EditEntitlementsForm,
  editMetadata: EditMetadataForm,
  renew: RenewForm,
  reactivate: ReactivateForm,
  revoke: RevokeForm,
}

type Props = {
  action: LicenseActionId | null
  license: LicenseResponseBody
  onClose: () => void
}

export function LicenseActionDialog({
  action,
  license,
  onClose,
}: Readonly<Props>) {
  const Form = action ? FORMS[action] : null

  return (
    <Dialog.Root
      open={action !== null}
      onOpenChange={(details) => {
        if (!details.open) {
          onClose()
        }
      }}
      size="md"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            {Form ? <Form license={license} onSuccess={onClose} /> : null}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
